import useExpressScheme from '@/utils/use-express-scheme'

// 在快递app中打开浏览器
export default function openBrowserInExpress (target) {
  useExpressScheme(`flashexpress://fe/browser?url=${encodeURIComponent(target)}`)
}
